import { FC } from "react";
import { Icon } from "../../../../../../components";

type Props = {
  category: string;
};

const iconsMap: Record<string, string> = {
  process: "process-diagram",
  synchronisation: "process",
  file: "format",
  misc: "folder-misc",
  ui: "user-interface"
};

const ProcessDetailsIcon: FC<Props> = ({ category }) => (
  <Icon
    className="large-font"
    title={category}
    name={iconsMap[category] || category}
  />
);

export default ProcessDetailsIcon;
